import { monthChip } from '../lib/hq-dates';
import { useHqMonth } from '../lib/hq-month-store';
import { HqIcon } from './HqIcon';

/** The month of the top bar: back and forward, never past the month Panama is in. */
export function HqMonthSwitch() {
  const { month, isCurrent, shift } = useHqMonth();
  return (
    <div className="hq-month" role="group" aria-label="Mes">
      <button type="button" className="hq-month-step" aria-label="Mes anterior" onClick={() => shift(-1)}>
        <HqIcon name="izquierda" size={16} />
      </button>
      <strong className="hq-month-name">{monthChip(month)}</strong>
      <button type="button" className="hq-month-step" aria-label="Mes siguiente" disabled={isCurrent} onClick={() => shift(1)}>
        <HqIcon name="derecha" size={16} />
      </button>
    </div>
  );
}
